import { render, staticRenderFns } from "./faqBox.vue?vue&type=template&id=5511df30&scoped=true"
import script from "./faqBox.vue?vue&type=script&lang=js"
export * from "./faqBox.vue?vue&type=script&lang=js"
import style0 from "./faqBox.vue?vue&type=style&index=0&id=5511df30&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5511df30",
  null
  
)

export default component.exports